import { ClassKey } from './constants/class.constants';

// shared with the UI's menu.service getRouteLink, so public API links match the UI's own routing
export function isClassTypeNav(cls: string): boolean {
  return cls === ClassKey.SAN || cls === ClassKey.LAN || cls === ClassKey.TAPE;
}

// null if any part is missing, so callers don't build a half link; storage falls back to the type tree like the UI does
export function uiPathOf(cls: string, hwType: string, page: string, itemId: string): string | null {
  if (!cls || !hwType || !page || !itemId) {
    return null;
  }
  const byType = isClassTypeNav(cls) || cls === ClassKey.STORAGE;
  return `/${cls}${byType ? '/type' : ''}/${hwType}/${page}?item_id=${itemId}`;
}
